import pinia from '@/store.js';
import { defineStore } from "pinia";

export const useForcePortraitStore = defineStore('ForcePortraitStore', {
    state: () => ({
        forceportrait: false,
        originalWindowHeight: 0,
        originalWindowWidth: 0
    }),
    getters: {
    },
    actions: {
    }
});
